import { BaseModel } from '../../_base/crud';
import { Role } from './role.model';


export class User extends BaseModel {
	password: string;
	user_id: string;
	mobile: string;
	employee_number: string;
	full_name: string;
	role_id: string;
	driver_company_id: number;
	cashier_area_id: number;
	s3_id: string;
	blocked: boolean;
	block_reason: string;
	role:Role;
	shift_id?:string;
	company:string;
	pic:string;
	


    clear(): void {
        this.user_id = undefined;
        this.password = '';
        this.mobile = '';
        this.full_name = '';
        this.role_id = '';
        this.driver_company_id = null;
        this.cashier_area_id = null;
        this.s3_id = '';
        this.blocked = null;
        this.block_reason = '';
		this.role = new Role;
		this.role.clear();
		this.shift_id= '';
		this.company= '';
		this.pic = '';
    }
}
